import { createSelector } from '../utils/selector-utils'
import {
  selectUsedOralSedativeTotalsAsArray,
  selectUsedParenDrugTotalsAsArray,
} from './drug-totals'
import { eventSelectors } from './events'
import { selectEarliestIvPlacedTime, selectLatestIvRemovedTime } from './fluids'
import { selectSedativesBeingUsed } from './sedation-level'

const {
  selectAnesthesiaMinutes,
  selectSurgeryMinutes,
  selectRecoveryMinutes,
  selectCompleteCaseMinutes,
  selectMonitoringMinutes,
  selectEventTimesRaw,
} = eventSelectors

export const selectEventsForCaseSummary = createSelector(
  selectEventTimesRaw,
  selectEarliestIvPlacedTime,
  selectLatestIvRemovedTime,
  (events, earliestIv, latestIvRemoved) => {
    const toReturn = { ...events }
    if (earliestIv) {
      toReturn.ivStart = earliestIv
    }
    if (latestIvRemoved) {
      toReturn.ivEnd = latestIvRemoved
    }
    return toReturn
  }
)

export const selectCaseSummary = createSelector(
  selectUsedParenDrugTotalsAsArray,
  selectUsedOralSedativeTotalsAsArray,
  selectEventsForCaseSummary,
  selectAnesthesiaMinutes,
  selectSurgeryMinutes,
  selectRecoveryMinutes,
  selectCompleteCaseMinutes,
  selectMonitoringMinutes,
  selectSedativesBeingUsed,
  (
    parenDrugsUsed,
    oralSedativesUsed,
    events,
    anesthesiaMinutes,
    surgeryMinutes,
    recoveryMinutes,
    completeCaseMinutes,
    monitoringMinutes,
    sedativesBeingUsed
  ) => ({
    parenDrugsUsed,
    oralSedativesUsed,
    events,
    anesthesiaMinutes: sedativesBeingUsed ? anesthesiaMinutes || 0 : null,
    surgeryMinutes: surgeryMinutes || 0,
    recoveryMinutes: sedativesBeingUsed ? recoveryMinutes || 0 : null,
    completeCaseMinutes: completeCaseMinutes || 0,
    monitoringMinutes: monitoringMinutes || 0,
  })
)
